import React from "react"
import { Link } from "gatsby"
import PropTypes from "prop-types"
import { Row, Col, Nav } from 'react-bootstrap';
import ThemeContext from "../context/ThemeContext"

const DarkModeToggle = ({ siteTitle }) => (
  <ThemeContext.Consumer>
    {theme => (
      <button className="dark-switcher" onClick={theme.toggleDark}>
        {theme.dark ? <span>Light mode ☀</span> : <span>Dark mode ☾</span>}
      </button>
    )}
  </ThemeContext.Consumer>
)

DarkModeToggle.propTypes = {
  siteTitle: PropTypes.string,
}

DarkModeToggle.defaultProps = {
  siteTitle: `Tonye's Blog`,
}

export default DarkModeToggle;
